import React, { useEffect, useState } from 'react'
import { FormulaComponent } from 'src/components/pages/sales/business-rule/logic/FormulaComponent'
import {
  Skeleton,
  Box,
  Typography,
  CircularProgress,
  Grid,
  TextField,
  Checkbox,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
} from '@mui/material'
import { CheckboxContext } from 'src/components/pages/sales/business-rule/logic/CheckboxContext'
import { useNotify, useTranslate } from 'react-admin'
import { formatCheckedBox, updateCheckBox } from 'src/components/pages/sales/business-rule/helper/vars_helper'
import { checkFormulasBody } from 'src/components/pages/sales/business-rule/helper/checkFormulasBody'
import { operators } from 'src/components/pages/sales/business-rule/logic/ListOperators'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import {
  transformData,
  tranformFormula,
} from 'src/components/pages/sales/business-rule/helper/formula_helper'
import { getAirports } from '../../reservation/logic/air/AirScaleRow'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { ShowCard } from 'src/components/uiElements/cards/ShowCard'
import LoadingButton from '@mui/lab/LoadingButton'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import { mapperHelperService } from 'src/services/auth/mapperHelper.service'

export const CardTestFormula = ({
  child_formula = undefined,
  currentParentRuleId = undefined,
  child_checkedBox = undefined,
  openTestFormula = false,
  handleCloseTestFormula = null,
  jsonRequestExample = null,
}) => {
  const notify = useNotify()
  const translate = useTranslate()
  const [loading, setLoading] = useState(false)
  const [checkedBox, setCheckedBox] = useState([])
  const [variablesFormat, setVariablesFormat] = useState([])
  const [formulaTest, setFormulasTest] = useState([])
  const [testStructureFormula, setTestStructureFormula] = useState()
  const [testParentRuleInfo, setParentTestRuleInfo] = useState()
  const [testFormulaSolve, setTestFormulaSolve] = useState({})
  const [errorFormula, setErrorFormula] = useState(false)
  const [reservation, setReservation] = useState(null)
  const [reservationNumber, setReservationNumber] = useState(null)
  const [reservationLoading, setReservationLoading] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  useEffect(() => {
    if (selectedItem) {
      testFormula(selectedItem)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem])

  useEffect(() => {
    if (jsonRequestExample) {
      testFormula(null, jsonRequestExample)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonRequestExample])

  const mapperJsonParse = async (jsonParse) => {
    if (jsonParse) {
      try {
        if (jsonParse.length !== 0) {
          const jsonParseHelper = await mapperHelperService(jsonParse)
          return jsonParseHelper
        } else {
          return {}
        }
      } catch (error) {
        notify('ra.field.invalid_json', { type: 'error' })
        return {}
      }
    }
  }

  const onError = (reservation_number) => {
    notify('ra.message.reservation_not_found', {
      type: 'error',
      messageArgs: { reservation_number: reservation_number },
    })
  }

  const searchReservationByNumber = async (number) => {
    try {
      setReservationLoading(true)
      const reservationData = await reservationServices.getOneByParams({
        number__ilike_in: number,
      })
      const reservation = await reservationServices.getById(reservationData?.[0]?.id)
      if (reservation) {
        setReservation(reservation)
        return reservation
      }
      setReservation(null)
      onError(number)
      return null
    } catch (error) {
      setReservation(null)
      onError(number)
    } finally {
      setReservationLoading(false)
    }
  }

  const formatPricingRelation = (pricing_relation) => {
    try {
      if (pricing_relation) {
        const pricing = pricing_relation[0]
        delete pricing.liquidation_retail
        delete pricing.liquidation_supplier
        delete pricing.liquidation_wholesaler
        const data = {
          data: {
            item: pricing,
          },
        }
        return data
      }
    } catch (error) {
      notify('ra.message.error_to_format_pricing', {
        type: 'error',
      })
      return {}
    }
  }

  const testFormula = async (selectedItem, jsonRequestExample = null) => {
    try {
      setLoading(true)
      let jsonParse = null
      if (selectedItem) {
        jsonParse = formatPricingRelation(selectedItem?.pricing_relation)
      }

      if (jsonRequestExample) {
        jsonParse = jsonRequestExample
      }
      if (child_formula && jsonParse) {
        let formula = {
          structure: tranformFormula(child_formula),
          data: transformData(jsonParse, child_checkedBox), // pisa los valores del item por defecto(child_checkedBox), por el seleccionado
        }
        if (checkFormulasBody(formula)) {
          let solvedFormula = await businessRuleServices.solvedFormulaTest(
            formula,
            currentParentRuleId ? currentParentRuleId : null
          )
          if (solvedFormula) {
            let valueCheckBox = null
            jsonParse = await mapperJsonParse(jsonParse)
            if (jsonParse && solvedFormula?.combine_formula?.data) {
              valueCheckBox = updateCheckBox(
                jsonParse,
                solvedFormula?.combine_formula?.data,
                [],
                setCheckedBox
              )
            }
            setTestStructureFormula(solvedFormula?.combine_formula?.structure)
            setParentTestRuleInfo(solvedFormula?.parent_rule_info)
            setTestFormulaSolve(solvedFormula?.formula_applied)
            let format_checkedBox = formatCheckedBox(valueCheckBox, operators, variablesFormat, formulaTest)
            setVariablesFormat(format_checkedBox)
            setErrorFormula(false)
            return
          }
        }
      }

      setTestFormulaSolve(null)
      setErrorFormula(true)
    } catch (error) {
      console.log('error', error)
      setErrorFormula(true)
    } finally {
      setLoading(false)
    }
  }

  const handleCheckboxChange = (item) => {
    if (selectedItem?.item_id === item.item_id) {
      setSelectedItem(null)
    } else {
      setSelectedItem(item)
    }
  }

  const getProductName = (item) => {
    if (item?.product?.ref_table_detail === 'hotel_detail') {
      return item?.name
    } else if (item?.product?.ref_table_detail === 'car_detail') {
      return item?.provider
    } else if (
      item?.product?.ref_table_detail === 'assistance_detail' ||
      item?.product?.ref_table_detail === 'other_detail'
    ) {
      return `${item.destination} / ${item.name}`
    } else if (item?.product?.ref_table_detail === 'transfer_detail') {
      return item?.pickup_origin
    } else if (item?.product?.ref_table_detail === 'air_detail') {
      return getAirports(item?.segments?.[0]?.itineraryGroup)
    } else if (item?.product?.ref_table_detail === 'train_detail_segment') {
      return `${item?.segments?.[0]?.origin_name}/${item?.segments?.[0]?.arrival_name}`
    } else if (item?.product?.ref_table_detail === 'train_detail_passes') {
      return item?.passes?.[0]?.company_name
    }
  }

  return (
    <Modal
      open={openTestFormula}
      onClose={handleCloseTestFormula}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minHeight: 400,
          minWidth: 900,
          height: 'auto',
          width: '90%',
          bgcolor: 'background.paper',
          border: '2px solid #000',
          borderRadius: '10px',
          boxShadow: 24,
          p: 4,
          overflowY: 'auto',
          maxHeight: '90vh',
        }}
      >
        <CheckboxContext.Provider value={{ checkedBox, setCheckedBox, variablesFormat, setVariablesFormat }}>
          {!jsonRequestExample && (
            <Grid container spacing={3} sx={{ marginY: '30px' }}>
              <Grid container alignItems='center' spacing={2}>
                <Grid item xs={12} sm={6}>
                  <EditInputsWrap
                    label={translate('ra.field.reservation_number')}
                    md={12}
                    lg={12}
                    style={{ minHeight: 0 }}
                  >
                    <TextField
                      onChange={(e) => setReservationNumber(e.target.value)}
                      size='small'
                      label={translate('ra.field.reservation_number')}
                      fullWidth
                      sx={{
                        '& legend': { display: 'none' },
                        '& .MuiInputLabel-shrink': { opacity: 0, transition: 'all 0.2s ease-in' },
                      }}
                    />
                  </EditInputsWrap>
                </Grid>
                <Grid item xs={12} sm={2} sx={{ marginTop: '40px' }}>
                  <EditInputsWrap label={null} md={12} lg={12}>
                    <LoadingButton
                      variant='contained'
                      onClick={() => searchReservationByNumber(reservationNumber)}
                      loading={reservationLoading}
                      fullWidth
                    >
                      {translate('ra.action.search')}
                    </LoadingButton>
                  </EditInputsWrap>
                </Grid>
              </Grid>
              <Grid item xs={12}></Grid>
              {reservation && (
                <ShowCard title={translate('ra.field.reservation_item')}>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>{translate('ra.field.type')}</TableCell>
                          <TableCell>{translate('ra.field.item_descripcion')}</TableCell>
                          <TableCell>{translate('ra.field.created_at')}</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {reservationLoading ? (
                          <TableRow>
                            {[...Array(3)].map((_, i) => (
                              <TableCell key={i}>
                                <Skeleton variant='rectangular' width={'100%'} height={20} />
                              </TableCell>
                            ))}
                          </TableRow>
                        ) : (
                          <>
                            {reservation?.items?.map((row, i) => (
                              <TableRow key={i}>
                                <TableCell>
                                  <Checkbox
                                    style={{ padding: 0, width: 18 }}
                                    checked={selectedItem?.item_id === row?.item_id}
                                    onChange={() => handleCheckboxChange(row)}
                                  />
                                </TableCell>
                                <TableCell>{row?.product?.product_type_relation?.long_name}</TableCell>
                                <TableCell>{getProductName(row)}</TableCell>
                                <TableCell>
                                  <ShowElement data={row?.created_at} label={null} dateTime />
                                </TableCell>
                              </TableRow>
                            ))}
                          </>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </ShowCard>
              )}
            </Grid>
          )}

          <Box
            style={{
              marginRight: '30px',
              display: 'flex',
              justifyContent: 'center',
              width: '90%',
            }}
          >
            {loading && (
              <Box>
                <CircularProgress />
              </Box>
            )}
          </Box>

          <Box
            style={{
              marginRight: '30px',
              display: 'flex',
              justifyContent: 'center',
              width: '90%',
            }}
          >
            {errorFormula ? (
              translate('ra.message.error_formula')
            ) : (
              <Box style={{ width: '100%' }}>
                {testParentRuleInfo && (
                  <Typography variant='h4' component='h2'>
                    Formula combinada con "{testParentRuleInfo?.name}"
                  </Typography>
                )}
                {testStructureFormula && testFormulaSolve && (
                  <FormulaComponent
                    formulas={formulaTest}
                    setFormulas={setFormulasTest}
                    initialFormulas={testStructureFormula}
                    formula_applied={testFormulaSolve?.formula_applied}
                    withoutVars={true}
                    onlyView={true}
                    loading={loading}
                  />
                )}
              </Box>
            )}
          </Box>
        </CheckboxContext.Provider>
      </Box>
    </Modal>
  )
}
